import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Usuario/cambiarEstadoUsuarioSeleccion`, method: 'POST', body: list, token: token})
}
